import{ forwardRef, useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import logo from '../assets/images/logo-Artistto.png';
import { GOOGLE_SCRIPT_URL } from '../config/googleSheets';

const ArtisttoFooter = forwardRef((props, ref) => {
  const companyLinks = [
    {name:'About Artistto', redirection:'/about-us'},
    {name:'Community', redirection:'https://chat.whatsapp.com/BFxWm1sdDXJD5DFK7uF57h'},
    {name:'Music Marketing', redirection:'/music-marketing'},
    {name:'Audio & Video Production', redirection:'/audio-video-production'},
    {name:'Contact', redirection:'/contact'},
  ];

  const contactLinks = [
  // {
  //   text: 'connect.artistto@gmail.com',
  //   redirection: 'mailto:connect.artistto@gmail.com'
  // },
  {
    text: 'connect@artistto.com',
    redirection: 'mailto: connect@artistto.com '
  },
  {
    text: '+91-7217679356',
    redirection: 'telto:+917217679356'
  },

  ];
  

  const socialIcons = [
    {
      name: 'X',
      path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
      redirection: 'https://www.instagram.com/artistto.music'
    },
    {
      name: 'LinkedIn',
      path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
      redirection: 'https://www.instagram.com/artistto.music'

    },
    {
      name: 'Facebook',
      path: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
      redirection: 'https://www.instagram.com/artistto.music'

    },
    {
      name: 'YouTube',
      path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
      redirection: 'https://www.instagram.com/artistto.music'

    },
    {
      name: 'Instagram',
      path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
      redirection: 'https://www.instagram.com/artistto.music'

    }
  ];

  // Scroll to top functionality
  const [isScrollToTopVisible, setIsScrollToTopVisible] = useState(false);

  // Show scroll to top button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsScrollToTopVisible(true);
      } else {
        setIsScrollToTopVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = () => {
    if (!email) return;
  setSubscribed(true);
       
    const formData = new FormData();
    formData.append('email', email);

    fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      body: formData,
      mode: 'no-cors'
    })
      .then(() => {
        
        // Reset back to "Subscribe" after 3 seconds
        setTimeout(() => {
          setSubscribed(false);
 setEmail('');

        }, 2000);
      })
      .catch((error) => {
        console.error('Submission error:', error);
      });
  };
  return (
    <>
      <footer className="bg-black text-white p-8 lg:p-16" ref={ref}>
        <div className="max-w-7xl mx-auto">
          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Logo and Email Subscription - Full width on mobile, 2 cols on desktop */}
            <div className="lg:col-span-2 order-1 lg:order-1">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-2 md:mb-16"><img src={logo} alt='Artistto' className='w-[84px] h-[35px] md:w-[220px] md:h-[95px] object-contain' />  </h2>
              <div className="hidden lg:flex gap-4">
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-transparent border border-white px-4 py-3 text-white placeholder-white rounded-lg
          flex-1 focus:outline-none focus:border-white max-w-[250px]"
        />
        <button
          onClick={handleSubscribe}
          disabled={subscribed}
          className={`bg-white border border-white-600 rounded-lg px-6 py-3 transition-all duration-300 
          text-black ${subscribed ? ' text-black' : 'hover:bg-white hover:text-black'}`}
        >
          {subscribed ? 'Subscribed' : 'Subscribe'}
        </button>
      </div>
            </div>

            {/* Company Section */}
            <div className="order-2 lg:order-2">
              <h3 className="text-white font-normal mb-4 lg:mb-6 text-sm tracking-wider">COMPANY</h3>
              <ul className="space-y-3 lg:space-y-4">
                {companyLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.redirection} className="text-white opacity-50 transition-colors">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Section */}
            <div className="order-3 lg:order-3">
              <h3 className="text-white font-normal mb-4 lg:mb-6 text-sm tracking-wider">CONTACT</h3>
              <ul className="space-y-3 lg:space-y-4">
                {contactLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.redirection} className="text-white opacity-50 transition-colors">
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="  pt-8 mt-8">
            <div className="flex flex-col lg:flex-row justify-between items-baseline md:items-center">
              <p className="text-white opacity-50 text-sm mb-4 lg:mb-0">© 2025 Artistto, Ltd</p>

              {/* Social Icons */}
              <div className="flex space-x-4">
                {socialIcons.map((icon, index) => (
                  <a
                    key={index}
                    href={icon.redirection}
                    className="text-white-400 hover:text-white transition-colors"
                    aria-label={icon.name}
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d={icon.path} />
                    </svg>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Scroll to Top Button */}
      {isScrollToTopVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-24 right-6 z-[1101] bg-[#FF8000] hover:bg-orange-600 text-white p-3 rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          aria-label="Scroll to top"
        >
          <ChevronUp size={24} />
        </button>
      )}
    </>
  );
});

export default ArtisttoFooter;